angular.module('picmonicng').directive('prelearnOverlay', [
  'LearnService',
  'UserService',
  'PlaylistService',
  'MarketOptionsConfig',
  '$state',
  'TokenService',
  'SalesforceResource',
  'User',
  'ngBowser',
  'BrowseService',
  '$modal',
  'SplitTestService',
  '$cookies',
  '$filter',
  '$rootScope',
  '$http',
  function (
    LearnService,
    UserService,
    PlaylistService,
    MarketOptionsConfig,
    $state,
    TokenService,
    SalesforceResource,
    User,
    ngBowser,
    BrowseService,
    $modal,
    SplitTestService,
    $cookies,
    $filter,
    $rootScope,
    $http
  ) {
    return {
      restrict: 'E',
      replace: true,
      templateUrl: UserService.user.user_id
        ? '/templates/modals/learn-prelearn.html'
        : '/templates/modals/learn-prelearn-guest.html',
      link: function (scope, element, attrs) {
        // Close pre-learn overlay when clicking behind the modal
        element.on('click', '.prelearn-overlay-backdrop, .modal-body', function (e) {
          if (
            UserService.user.user_id &&
            !UserService.user.is_trial &&
            LearnService.currentCard.card_id &&
            (e.target.className.indexOf('modal-body') != -1 ||
              e.target.className.indexOf('prelearn-overlay-backdrop') != -1)
          ) {
            scope.$apply(function () {
              LearnService.dismissPrelearnModal();
            });
          }
        });

        scope.LearnService = LearnService;
        scope.UserService = UserService;
        scope.BrowseService = BrowseService;
        scope.shortcut = LearnService.randomShortcut(true);

        if (UserService.user.user_id) {
          scope.TokenService = TokenService;

          scope.spacedRepStats = User.getv3({ resource: 'spacedrepstats' }, function (data) {
            if (!UserService.user.spaced_rep_date && data.next > 0) {
              UserService.user.spaced_rep_date = new Date().toISOString().slice(0, 10);
            }
          });

          TokenService.values.$promise.then(function () {
            LearnService.loadingPromise.then(function () {
              scope.canPlay = LearnService.currentCard.is_owned || TokenService.values.tokens;
              scope.canQuiz =
                !UserService.user.is_trial ||
                TokenService.values.quiz_questions ||
                LearnService.currentCard.is_free ||
                LearnService.currentCard.is_owned;
              scope.canSpacedRep =
                (!UserService.user.is_trial || TokenService.values.spacedrep_rounds) &&
                (scope.spacedRepStats.next > 0 || scope.spacedRepStats.current_left > 0) &&
                !$rootScope.embed;
              scope.playTitle =
                UserService.user.is_trial &&
                LearnService.currentCard.is_owned &&
                LearnService.currentCard.lastviewed > 0
                  ? 'REPLAY PICMONIC'
                  : 'PLAY PICMONIC';
              scope.inMarket =
                !!$filter('filter')(LearnService.currentCard.primary_tracks, { market_id: UserService.user.lead }, true)
                  .length ||
                $filter('filter')(LearnService.currentCard.primary_tracks, {
                  market_is_pseudo: 1,
                }).length;
              if (!scope.canPlay && UserService.user.approved_educator) {
                scope.canQuiz = false;
                scope.canSpacedRep = false;
              }

              scope.inActiveMarket = false;
              angular.forEach(LearnService.currentCard.primary_tracks, function (primary_track) {
                if (
                  !!$filter('filter')(UserService.user.active_markets, { market_id: primary_track.market_id }, true)
                    .length
                ) {
                  scope.inActiveMarket = true;
                }
                if (
                  !!$filter('filter')(UserService.user.market.addons, { market_id: primary_track.market_id }, true)
                    .length
                ) {
                  scope.inMarket = true;
                  scope.addonMarket = primary_track.market_id;
                }
              });

              if (!scope.inMarket) {
                if (typeof atlasEvent !== 'undefined') {
                  atlasEvent('seen', 'prelearn_modal_out_of_market');
                }
              }

              if (!scope.canPlay && UserService.user.is_trial) {
                SalesforceResource.save({
                  resource: 'event',
                  eventName: 'tokens-out-last-viewed-picmonic',
                  fields: {
                    card_id: LearnService.currentCard.card_id,
                    card_name: LearnService.currentCard.name,
                    card_slug: LearnService.currentCard.slug,
                    card_img: LearnService.currentCard.main_image,
                  },
                });
              }

              if (!scope.canPlay && !UserService.user.approved_educator) {
                $http.post('/api/v3/push_notifications/event/paywall', {
                  card_id: LearnService.currentCard.card_id,
                  card_name: LearnService.currentCard.name,
                  card_slug: LearnService.currentCard.slug,
                  card_img: LearnService.currentCard.main_image,
                });
              }
            });
          });
        } else {
          //scope.canPlayOne =  !($cookies.get('pls_picmonic_played') || window.localStorage.getItem('picmonic_played'));
          scope.canPlayOne = false;
          scope.register = function () {
            if (scope.canPlayOne) {
              $cookies.put('pls_picmonic_played', 1);
              try {
                window.localStorage.setItem('picmonic_played', 1);
              } catch (error) {}
              UserService.user.has_seen = {};
              UserService.user.settings = { learn_theater: 1 };
              UserService.user.audio_speed = 1;
              UserService.user.audio_volume = 1;
              LearnService.currentCard.is_owned = 1;
              scope.play();
            } else {
              window.location = '/?register=1&redirect=/learn/' + LearnService.currentCard.slug;
            }
          };
        }

        scope.market = MarketOptionsConfig.getMarketById(UserService.user.lead);

        scope.link = scope.market ? scope.market.pricing_url : '/pricing';

        // Uncomment this to allow cycling through random shortcuts
        // scope.randomShortcut = function() {
        scope.shortcut = LearnService.randomShortcut(true);
        //};
        //scope.randomShortcut();

        scope.play = function () {
          if (!scope.loading) {
            scope.loading = true;

            // i think they caught on to our hack
            // if(ngBowser.isMobile() || ngBowser.isTablet()){
            //     // <HACK FOR MOBILE TOKEN REDEMPTION>
            //     if(LearnService.audioElement) {
            //         LearnService.audioElement.muted = true;
            //         LearnService.audioElement.play();
            //     }
            //     // </HACK FOR MOBILE TOKEN REDEMPTION>
            // }

            LearnService.dismissPrelearnModal()
              .then(function () {
                return LearnService.checkPostPreLearnModals();
              })
              .then(function () {
                if (scope.make_default) {
                  UserService.user.show_prelearn_modal = 0;
                  UserService.user.$update();
                }

                LearnService.startLearn();

                // i think they caught on to our hack
                // if(ngBowser.isMobile() || ngBowser.isTablet()) {
                //     // <HACK FOR MOBILE TOKEN REDEMPTION>
                //     LearnService.audioElement.muted = false;
                //     // </HACK FOR MOBILE TOKEN REDEMPTION>
                // }

                PlaylistService.open = false;
                LearnService.playPauseAudio();
                if (LearnService.audioElement) {
                  angular.element('#audio-toggle-control').focus();
                }

                if (typeof atlasEvent !== 'undefined') {
                  atlasEvent('click', 'pre-learn modal play', 'new_user');
                }

                send_ga('event', 'Pre-Learn Modal', 'Play', 'Play');
              })
              .finally(function () {
                scope.loading = false;
              });
          }
        };

        scope.subscribe = function () {
          if (typeof atlasEvent !== 'undefined') {
            atlasEvent('free limit overlay', 'subscribe');
          }

          document.location.href = scope.link;
        };

        scope.quiz = function () {
          if (scope.make_default) {
            UserService.user.show_prelearn_modal = 0;
            UserService.user.$update();
          }

          //scope.close();
          PlaylistService.open = false;

          LearnService.dismissPrelearnModal(true).then(function () {
            LearnService.startQuiz();
          });
        };

        scope.spacedRep = function () {
          if (scope.spacedRepStats.current_left == 0 && scope.spacedRepStats.next > 0) {
            User.savev3({ resource: 'spacedrep' }, function () {
              $state.go('app.quiz', {
                quiz_type: 'spacedrep',
                resource_id: 'today',
              });
            });
          } else {
            $state.go('app.quiz', {
              quiz_type: 'spacedrep',
              resource_id: 'today',
            });
          }
        };
      },
    };
  },
]);
